import React from 'react';

export default function WindowResizeComponent(...mix) {
  return React.createClass({
    mixins: [...mix],

    getInitialState: function getInitialState() {
      return {
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight
      };
    },

    handleResize: function handleResize(e) {
      this.setState({
         windowWidth: window.innerWidth,
         windowHeight: window.innerHeight
      });
    },

    componentDidMount: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
    },

    componentWillUnmount: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    },

    render: function baseRender() {
      return <div></div>;
    }
  });
}


/** WEBPACK FOOTER **
 ** ./src/components/WindowResizeComponent.jsx
 **/